export const SWITCH_QUEUED = 'SWITCH_QUEUED'
export const SWITCH_ACTIVE = 'SWITCH_ACTIVE'
export const SWITCH_FINISHED = 'SWITCH_FINISHED'
export const SWITCH_SAVED = 'SWITCH_SAVED'
